<div class="g-layout__container">
    <!-- Page Header -->
    <div class="reports-header">
        <div class="reports-title">
            <i class="fa-solid fa-file-chart-line"></i>
            <span>{{ 'Reports' | navTitle | async }}</span>
        </div>
    </div>
    <div class="br"></div>
    
    <!-- Strategy Selector -->
    <div class="strategy-selector">
        <label class="selector-label">
            <i class="fa-solid fa-bullseye"></i>
            {{'select_the_strategy' | translate}}
        </label>
        <p-dropdown [(ngModel)]="selectedStrategyId"
                    [options]="strategyOptions" 
                    optionLabel="name" 
                    optionValue="strategyId"
                    (onChange)="strategyOptionsChange()"
                    placeholder="{{'select_the_strategy' | translate}}">
        </p-dropdown>
    </div>

    <!-- Reports Table -->
    <div class="reports-table-container">
        <p-table [class]="dir" 
                 [value]="reports"
                 styleClass="modern-reports-table">
            
            <!-- Table Header -->
            <ng-template pTemplate="header">
                <tr>
                    <th>
                        <div class="header-cell">
                            <i class="fa-solid fa-file-lines"></i>
                            <span>{{ 'report' | translate }}</span>
                        </div>
                    </th>
                    <th>
                        <div class="header-cell">
                            <i class="fa-solid fa-sliders"></i>
                            <span>{{ 'options' | translate }}</span>
                        </div>
                    </th>
                    <th>
                        <div class="header-cell">
                            <i class="fa-solid fa-download"></i>
                            <span>{{ 'download' | translate }}</span>
                        </div>
                    </th>
                </tr>
            </ng-template>

            <!-- Table Body -->
            <ng-template pTemplate="body" let-report let-rowIndex="rowIndex">
                <tr class="report-row" [style.animation-delay]="(rowIndex * 0.1) + 's'">
                    
                    <!-- Report Name -->
                    <td>
                        <button class="report-view-btn" (click)="showReportInTable(report.id)">
                            <i [class]="report.icon"></i>
                            <span>{{ report.name }} {{ report.hasDate ? year : '' }}</span>
                        </button>
                    </td>

                    <!-- Options (Dropdowns) -->
                    <td>
                        <div class="options-container">
                            @if(report.hasDate) {
                            <div class="option-item">
                                <label class="option-label">
                                    <i class="fa-solid fa-calendar-days"></i>
                                    {{ 'select_reporting_year' | translate }}
                                </label>
                                <p-dropdown appendTo="body" 
                                            [(ngModel)]="year" 
                                            [options]="yearsOpthions"
                                            (onChange)="yearChange()"
                                            placeholder="{{ 'select_reporting_year' | translate }}">
                                </p-dropdown>
                            </div>
                            }

                            @if(report.hasProjects) {
                            <div class="option-item">
                                <label class="option-label">
                                    <i class="fa-solid fa-building"></i>
                                    {{ 'select_the_department' | translate }}
                                </label>
                                <p-dropdown appendTo="body" 
                                            [(ngModel)]="selectedDepartmentStatusId"
                                            [options]="departmentOptions" 
                                            optionLabel="label" 
                                            optionValue="id"
                                            (onChange)="dpartmentStatusChange()"
                                            placeholder="{{ 'select_the_department' | translate }}">
                                </p-dropdown>
                            </div>

                            <div class="option-item">
                                <label class="option-label">
                                    <i class="fa-solid fa-calendar-check"></i>
                                    {{ 'select_the_reporting_year' | translate }}
                                </label>
                                <p-dropdown appendTo="body" 
                                            [(ngModel)]="projectStatusYear"
                                            [options]="projectStatusYears" 
                                            optionLabel="name"
                                            (onChange)="projectStatusYearChange()"
                                            placeholder="{{ 'select_the_reporting_year' | translate }}">
                                </p-dropdown>
                            </div>
                            }

                            @if(report.hasBudget) {
                            <div class="option-item">
                                <label class="option-label">
                                    <i class="fa-solid fa-building"></i>
                                    {{ 'select_the_department' | translate }}
                                </label>
                                <p-dropdown appendTo="body" 
                                            [(ngModel)]="selectedDepartmentBudgetId"
                                            [options]="departmentOptions" 
                                            optionLabel="label" 
                                            optionValue="id"
                                            (onChange)="projectBudgetChange()"
                                            placeholder="{{ 'select_the_department' | translate }}">
                                </p-dropdown>
                            </div>

                            <div class="option-item">
                                <label class="option-label">
                                    <i class="fa-solid fa-calendar-check"></i>
                                    {{ 'select_the_reporting_year' | translate }}
                                </label>
                                <p-dropdown appendTo="body" 
                                            [(ngModel)]="projectBudgetYear"
                                            [options]="projectStatusYears" 
                                            optionLabel="name"
                                            (onChange)="projectBudgetYearChange()"
                                            placeholder="{{ 'select_the_reporting_year' | translate }}">
                                </p-dropdown>
                            </div>
                            }
                            
                            @if(!report.hasDate && !report.hasProjects && !report.hasBudget) {
                            <div class="no-options">
                                <i class="fa-solid fa-circle-info"></i>
                                <span>{{'no_additional_options' | translate}}</span>
                            </div>
                            }
                        </div>
                    </td>

                    <!-- Download & Print Buttons -->
                    <td>
                        <div class="download-actions">
                            <button class="download-btn pdf-btn" 
                                    (click)="downloadFile(report.id,'pdf')"
                                    [disabled]="isDownloading && report.id == selectedType"
                                    pTooltip="{{'download_pdf' | translate}}"
                                    tooltipPosition="top">
                                <i class="fa-solid fa-file-pdf"></i>
                                <span>PDF</span>
                            </button>

                            <button class="download-btn excel-btn" 
                                    (click)="downloadFile(report.id,'excel')"
                                    [disabled]="isDownloading && report.id == selectedType"
                                    pTooltip="{{'download_excel' | translate}}"
                                    tooltipPosition="top">
                                <i class="fa-solid fa-file-excel"></i>
                                <span>Excel</span>
                            </button>
                            
                            <button class="download-btn print-btn" 
                                    (click)="printReport(report.id)"
                                    [disabled]="!selectedType || selectedType !== report.id"
                                    pTooltip="{{'print_report' | translate}}"
                                    tooltipPosition="top">
                                <i class="fa-solid fa-print"></i>
                                <span>{{'print' | translate}}</span>
                            </button>

                            @if(isDownloading && report.id == selectedType) {
                            <div class="loading-spinner">
                                <i class="fa-solid fa-spinner fa-spin"></i>
                            </div>
                            }
                        </div>
                    </td>
                </tr>
            </ng-template>

            <!-- Empty State -->
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="3">
                        <div class="empty-state">
                            <i class="fa-solid fa-inbox"></i>
                            <p>{{'no_reports_available' | translate}}</p>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>

    <!-- Report Results Section -->
    @switch (selectedType) {
        @case("projects-status"){
        <div class="report-results">
            <div class="result-header">
                <i class="fa-solid fa-chart-line"></i>
                <h3>{{"progress_status_report_of_initiatives"|translate}} - {{projectStatusYear.name}}</h3>
            </div>

            <p-table [class]="dir" 
                     groupRowsBy="unit_name" 
                     sortField="unit_name" 
                     sortMode="single" 
                     [value]="projects"
                     rowGroupMode="rowspan"
                     styleClass="results-table">
                
                <ng-template pTemplate="header">
                    <tr>
                        <th></th>
                        <th>{{'organizational_unit' | translate}}</th>
                        <th>{{'report_initiative_name' | translate}}</th>
                        <th>{{'report_strategic_linkage' | translate}}</th>
                        <th>{{'indicator' | translate}}</th>
                        <th>{{'report_initiative_status' | translate}}</th>
                        <th>{{'report_execution_date' | translate}}</th>
                        <th>{{'report_progress_percentage' | translate}}</th>
                    </tr>
                </ng-template>

                <ng-template pTemplate="body" let-rowspan="rowspan" let-project let-rowIndex="rowIndex" let-rowgroup="rowgroup">
                    <tr>
                        <td class="font-bold">{{rowIndex+1}}</td>
                        <td *ngIf="rowgroup" [attr.rowspan]="rowspan">{{project.unit_name}}</td>
                        <td>{{project.name}}</td>
                        <td>
                            @for (projectMapping of project.projectMappings; track projectMapping) {
                            {{projectMapping.indicator_code}}
                            }
                        </td>
                        <td>
                            <ul class="indicator-list">
                                @for (projectMapping of project.projectMappings; track projectMapping) {
                                <li>{{projectMapping.indicator_name}}</li>
                                }
                            </ul>
                        </td>
                        <td class="text-center">
                            <p-tag severity="{{getSeverity(project.status_name)}}" value="{{ project.status_name}}" />
                        </td>
                        <td>
                            <div class="date-range">
                                <div class="date-item">
                                    <i class="fa-solid fa-calendar-day"></i>
                                    <span>{{project.start_date|date}}</span>
                                </div>
                                <div class="date-item">
                                    <i class="fa-solid fa-calendar-check"></i>
                                    <span>{{project.end_date|date}}</span>
                                </div>
                            </div>
                        </td>
                        <td>
                            <div class="progress-badge" [ngStyle]="{'background-color':getProgressColor(project.progress_percentage)}">
                                {{project.progress_percentage}}%
                            </div>
                        </td>
                    </tr>
                </ng-template>
                
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td class="text-center" [attr.colspan]="9">
                            <div class="no-data-message">
                                <i class="fa-solid fa-circle-exclamation"></i>
                                <span>{{'no_data_found' | translate}}</span>
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
        }
        
        @case("projects-budgets"){
        <div class="report-results">
            <div class="result-header">
                <i class="fa-solid fa-coins"></i>
                <h3>{{"budget_report_of_initiatives"|translate}} - {{projectBudgetYear.name}}</h3>
            </div>

            <p-table [class]="dir" 
                     rowGroupMode="rowspan" 
                     [value]="projectsBudjet"
                     styleClass="results-table">
                
                <ng-template pTemplate="header">
                    <tr>
                        <th>{{'index' | translate }}</th>
                        <th>{{'report_initiative_name' | translate}}</th>
                        <th>{{'report_owning_organizational_unit' | translate}}</th>
                        <th>{{'report_executive_responsible' | translate}}</th>
                        <th>{{'report_estimated_budget_for_execution' | translate}}</th>
                        <th>{{'report_within_department_budget_limit' | translate}}</th>
                        <th>{{'report_budget_item' | translate}}</th>
                        <th>{{'report_budget_amount' | translate}}</th>
                        <th>{{'report_budget_description' | translate}}</th>
                    </tr>
                </ng-template>
                
                <ng-template pTemplate="body" let-project let-rowIndex="rowIndex">
                    @if(project&&!project.projectResource?.budget_items?.length){
                    <tr>
                        <td class="font-bold">{{rowIndex+1}}</td>
                        <td [attr.rowspan]="project.projectResource?.budget_items.length||1">{{project.name}}</td>
                        <td [attr.rowspan]="project.projectResource?.budget_items.length||1">{{project.in_charge_unit_name}}</td>
                        <td [attr.rowspan]="project?.projectResource?.budget_items.length||1">{{project.in_charge_name}}</td>
                        <td class="font-bold text-center" [attr.rowspan]="project?.projectResource?.budget_items.length||1">
                            {{project.projectResource?.estimated_budget|currency:'AED'}}
                        </td>
                        <td class="font-bold text-center" [attr.rowspan]="project.projectResource?.budget_items.length||1">
                            {{project.projectResource?.is_within_budget_limit ? "نعم" : "لا"}}
                        </td>
                        <td class="font-bold text-center" colspan="3" rowspan="1">
                            <p-tag severity="danger" value='لا توجد بنود' />
                        </td>
                    </tr>
                    }

                    @for(item of project?.projectResource?.budget_items;track item){
                    <tr>
                        @if ($index== 0) {
                        <td class="font-bold">{{rowIndex+1}}</td>
                        <td [attr.rowspan]="project.projectResource?.budget_items.length||1">{{project.name}}</td>
                        <td [attr.rowspan]="project.projectResource?.budget_items.length||1">{{project.in_charge_unit_name}}</td>
                        <td [attr.rowspan]="project.projectResource?.budget_items.length||1">{{project.in_charge_name}}</td>
                        <td class="font-bold text-center" [attr.rowspan]="project.projectResource?.budget_items.length||1">
                            {{project.projectResource?.estimated_budget|currency:'AED'}}
                        </td>
                        <td class="font-bold text-center" [attr.rowspan]="project.projectResource?.budget_items.length||1">
                            {{project.projectResource?.is_within_budget_limit ? "نعم" : "لا"}}
                        </td>
                        }@else {
                        <td class="font-bold">{{rowIndex+1}}</td>
                        }
                        <td>{{item.name}}</td>
                        <td class="font-bold text-center">{{item.value|currency:'AED'}}</td>
                        <td>{{item.description}}</td>
                    </tr>
                    }
                </ng-template>
                
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td class="text-center" [attr.colspan]="9">
                            <div class="no-data-message">
                                <i class="fa-solid fa-circle-exclamation"></i>
                                <span>{{'no_data_found' | translate}}</span>
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
        }
        
        @case ("indicators-results") {
        <div class="report-results">
            <div class="result-header">
                <i class="fa-solid fa-chart-column"></i>
                <h3>{{"report_of_indicator_results_for_the_year"|translate}} - {{year}}</h3>
            </div>

            <p-table [class]="dir" 
                     [value]="indicators"
                     styleClass="results-table">
                
                <ng-template pTemplate="header">
                    <tr>
                        <th>{{'goal_code' | translate }}</th>
                        <th>{{'kpi_code' | translate }}</th>
                        <th>{{'name' | translate }}</th>
                        <th>{{'target' | translate }}</th>
                        <th>{{'actual' | translate }}</th>
                        <th>{{'indicator_data_source' | translate }}</th>
                        <th>{{'indicator_performance' | translate}}</th>
                    </tr>
                </ng-template>
                
                <ng-template pTemplate="body" let-indicator>
                    <tr>
                        <td>{{indicator.goal_code}}</td>
                        <td>{{indicator.code}}</td>
                        <td>{{indicator.name}}</td>
                        <td class="font-bold text-center">
                            @if(indicator.measurement_unit == "percentage"){
                                {{indicator.total_target}}%
                            }@else{
                                {{indicator.total_target}}
                            }
                        </td>
                        <td class="font-bold text-center">
                            @if(indicator.measurement_unit == "percentage"){
                                {{indicator.total_actual}}%
                            }@else{
                                {{indicator.total_actual}}
                            }
                        </td>
                        <td>{{indicator.data_source}}</td>
                        <td>
                            <div class="performance-cell">
                                <span class="performance-value">
                                    @if(indicator.performance == 0){ 100% }
                                    @else if(indicator.measurement_unit == "percentage"){ {{indicator.performance}}% }
                                    @else{ {{indicator.performance}} }
                                </span>
                                <div class="performance-icon">
                                    @if (indicator.performance==0) {
                                        <i class="fa-solid fa-minus text-blue-700"></i>
                                    }
                                    @if(indicator.measurement_unit_direction == "positive_increase_preferred"){
                                        @if (indicator.performance > 0) {
                                            <i class="fa-solid fa-arrow-up text-green-700"></i>
                                        }
                                        @if (indicator.performance < 0) {
                                            <i class="fa-solid fa-arrow-down text-red-700"></i>
                                        }
                                    }
                                    @if(indicator.measurement_unit_direction == "negative_decrease_preferred"){
                                        @if (indicator.performance > 0) {
                                            <i class="fa-solid fa-arrow-up text-red-700"></i>
                                        }
                                        @if (indicator.performance < 0) {
                                            <i class="fa-solid fa-arrow-down text-green-700"></i>
                                        }
                                    }
                                </div>
                            </div>
                        </td>
                    </tr>
                </ng-template>
                
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td class="text-center" [attr.colspan]="7">
                            <div class="no-data-message">
                                <i class="fa-solid fa-circle-exclamation"></i>
                                <span>{{'no_data_found' | translate}}</span>
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
        }
    }
</div>
